export const ADD_SUPPLIER = 'add:supplier';
export const EDIT_SUPPLIER = 'edit:supplier';
export const DELETE_SUPPLIER = 'inactive:supplier';
export const VIEW_SUPPLIER = 'view:supplier';
export const VIEW_SUPPLIER_LIST = 'view:supplier_list';


export const ADD_CATEGORY = 'add:category';
export const EDIT_CATEGORY = 'edit:category';
export const DELETE_CATEGORY = 'inactive:category';
export const VIEW_CATEGORY = 'view:category';
export const VIEW_CATEGORY_LIST = 'view:category_list';

export const ADD_ROLE = 'add:role';
export const EDIT_ROLE = 'edit:role';
export const DELETE_ROLE = 'inactive:role';
export const VIEW_ROLE = 'view:role';
export const VIEW_ROLE_LIST = 'view:role_list';

export const ADD_USER = 'add:user';
export const EDIT_USER = 'edit:user';
export const DELETE_USER = 'inactive:user';
export const VIEW_USER = 'view:user';
export const VIEW_USER_LIST = 'view:user_list';


export const ADD_PURCHASE_VOUCHER = 'add:purchase_voucher';
export const EDIT_PURCHASE_VOUCHER = 'edit:purchase_voucher';
export const APPROVE_PURCHASE_VOUCHER = 'approve:purchase_voucher';
export const VIEW_PURCHASE_VOUCHER = 'view:purchase_voucher';
export const VIEW_PURCHASE_LIST = 'view:purchase_list';

export const ADD_LOCAL_PURCHASE = 'add:local_purchase';
export const EDIT_LOCAL_PURCHASE = 'edit:local_purchase';
export const VIEW_LOCAL_PURCHASE_LIST = 'add:local_purchase_list';
export const APPROVE_LOCAL_PURCHASE = 'approve:local_purchase';

export const ADD_DEBIT_NOTE = 'add:debit_note';
export const EDIT_DEBIT_NOTE = 'edit:debit_note';
export const VIEW_DEBIT_NOTE_LIST = 'view:debit_note_list';
export const APPROVE_DEBIT_NOTE = 'approve:debit_note';
export const DELETE_DEBIT_NOTE = 'inactive:debit_note';

export const ADD_RAW_MATERIAL = 'add:raw_material';
export const VIEW_RAW_MATERIAL_LIST = 'view:raw_material_list';
export const EDIT_RAW_MATERIAL = 'edit:raw_material';
export const DELETE_RAW_MATERIAL = 'inactive:raw_material';

export const ADD_PRODUCT = 'add:product';
export const EDIT_PRODUCT = 'edit:product';
export const DELETE_PRODUCT = 'inactive:product';
export const ADD_PRODUCT_COST = 'add:product_cost';
export const VIEW_PRODUCT_LIST = 'view:product_list';

export const ADD_CUSTOMER = 'add:customer';
export const EDIT_CUSTOMER = 'edit:customer';
export const VIEW_CUSTOMER = 'view:customer';
export const DELETE_CUSTOMER = 'inactive:customer';
export const VIEW_CUSTOMER_LIST = 'view:customer_list';

export const ADD_OTHER_EXPENSE = 'add:other_expense';
export const EDIT_OTHER_EXPENSE = 'edit:other_expense';
export const VIEW_OTHER_EXPENSE = 'view:other_expense';
export const DELETE_OTHER_EXPENSE = 'inactive:other_expense';
export const VIEW_OTHER_EXPENSE_LIST = 'view:other_expense_list';

export const ADD_INVENTORY = 'add:inventory';
export const EDIT_INVENTORY = 'edit:inventory';
export const VIEW_INVENTORY = 'view:inventory';
export const DELETE_INVENTORY = 'inactive:inventory';
export const VIEW_INVENTORY_LIST = 'view:inventory_list';

export const ADD_VAT_TYPE = 'add:vat_type';
export const EDIT_VAT_TYPE = 'edit:vat_type';
export const VIEW_VAT_TYPE = 'view:vat_type';
export const DELETE_VAT_TYPE = 'inactive:vat_type';
export const VIEW_VAT_TYPE_LIST = 'view:vat_type_list';


export const EDIT_COMPANY_PROFILE = 'edit:company_profile';
export const VIEW_PERMISSION_LIST = 'view:permission_list';

export const VIEW_PRODUCT_ACTIVITIES = 'view:product_activities';
export const VIEW_PRODUCT_PRICE_HISTORY = 'view:product_price_history';

export const ADD_TRANSFER_VOUCHER = 'add:transfer_voucher';
export const EDIT_TRANSFER_VOUCHER = 'edit:transfer_voucher';
export const DELETE_TRANSFER_VOUCHER = 'inactive:transfer_voucher';
export const APPROVE_TRANSFER_VOUCHER = 'approve:transfer_voucher';
export const VIEW_TRANSFER_VOUCHER_LIST = 'view:transfer_voucher_list';

export const ADD_SALES_VOUCHER = 'add:sales_voucher';
export const EDIT_SALES_VOUCHER = 'edit:sales_voucher';
export const APPROVE_SALES_VOUCHER = 'approve:sales_voucher';
export const VIEW_SALES_VOUCHER = 'view:sales_voucher';
export const VIEW_SALES_LIST = 'view:sales_list';

export const ADD_CREDIT_NOTE = 'add:credit_note';
export const EDIT_CREDIT_NOTE = 'edit:credit_note';
export const VIEW_CREDIT_NOTE_LIST = 'view:credit_note_list';
export const APPROVE_CREDIT_NOTE = 'approve:credit_note';
export const VIEW_SALES_VOUCHER_LIST = 'view:sales_voucher_list';

export const VIEW_CREDIT_NOTE = 'view:credit_note';
export const DELETE_CREDIT_NOTE = 'inactive:credit_note';

export const ADD_EXPORT_VOUCHER = 'add:export_voucher';
export const EDIT_EXPORT_VOUCHER = 'edit:export_voucher';
export const APPROVE_EXPORT_VOUCHER = 'approve:export_voucher';
export const VIEW_EXPORT_VOUCHER = 'view:export_voucher';
export const VIEW_EXPORT_VOUCHER_LIST = 'view:export_voucher_list';

export const ADD_RECEIVE_PRODUCTS = 'add:receive_products';
export const EDIT_RECEIVE_PRODUCTS = 'edit:receive_products';
export const DELETE_RECEIVE_PRODUCTS = 'inactive:receive_products';
export const APPROVE_RECEIVE_PRODUCTS = 'approve:receive_products';
export const VIEW_RECEIVE_PRODUCTS_LIST = 'view:receive_products_list';

export const ADD_TRANSFER_PRODUCT = 'add:transfer_product';
export const EDIT_TRANSFER_PRODUCT = 'edit:transfer_product';
export const DELETE_TRANSFER_PRODUCT = 'inactive:transfer_product';
export const APPROVE_TRANSFER_PRODUCT = 'approve:transfer_product';
export const VIEW_TRANSFER_PRODUCT_LIST = 'view:transfer_product_list';


export const ADD_VDS_ISSUE = 'add:vds_issue';
export const VIEW_VDS_ISSUE_LIST = 'view:vds_issue_list';
export const ADD_VDS_RECEIVE = 'add:vds_receive';
export const VIEW_VDS_RECEIVE_LIST = 'view:vds_receive_list';
/**
 * Branch Permissions
 */
export const ADD_BRANCH = 'add:branch';
export const EDIT_BRANCH = 'edit:branch';
export const VIEW_BRANCH = 'view:branch';
export const DELETE_BRANCH = 'inactive:branch';
export const VIEW_BRANCH_LIST = 'view:branch_list';

export const ADD_PTRANSFER__VOUCHER = 'add:product_transfer_voucher';
export const EDIT_PTRANSFER_VOUCHER = 'edit:product_transfer_voucher';
export const APPROVE_PTRANSFER_VOUCHER = 'approve:product_transfer_voucher';
export const VIEW_PTRANSFER_VOUCHER = 'view:product_transfer_voucher';
export const VIEW_PTRANSFER_LIST = 'view:product_transfer_list';

export const ADD_BRANCH_RECEIVE_PRODUCT = 'add:branch_receive_product';
export const EDIT_BRANCH_RECEIVE_PRODUCT = 'edit:branch_receive_product';
export const VIEW_BRANCH_RECEIVE_PRODUCT_LIST = 'view:branch_receive_product_list';
export const APPROVE_BRANCH_RECEIVE_PRODUCT = 'approve:branch_receive_product';

export const ADD_BRANCH_SALES_VOUCHER = 'add:branch_sales_voucher';
export const EDIT_BRANCH_SALES_VOUCHER = 'edit:branch_sales_voucher';
export const APPROVE_BRANCH_SALES_VOUCHER = 'approve:branch_sales_voucher';
export const VIEW_BRANCH_SALES_VOUCHER = 'view:branch_sales_voucher';
export const VIEW_BRANCH_SALES_LIST = 'view:branch_sales_list';

export const ADD_SURCHARGE = 'add:surcharge';
export const EDIT_SURCHARGE = 'edit:surcharge';
export const VIEW_SURCHARGE = 'view:surcharge';

export const VIEW_MUSHAKS = 'view:mushaks';
export const VIEW_FIRST_SCHEDULE = 'view:first_schedules';
export const VIEW_SECOND_SCHEDULE = 'view:second_schedules';
export const VIEW_THIRD_SCHEDULE = 'view:third_schedules';
export const VIEW_PRODUCTS_ON_15_VAT = 'view:products_on_15_vat';
export const VIEW_TARIFF_SCHEDULE = 'view:tariff_schedules';
export const VIEW_BACKUP_LIST = 'view:backup_list';
export const VIEW_STOCK_REPORT = 'view:stock_report';

export const ADD_PRODUCT_SIZE = 'add:product_size';
export const EDIT_PRODUCT_SIZE = 'edit:product_size';
export const VIEW_PRODUCT_SIZE = 'view:product_size';
